/*
    This code creates a smooth fade-out effect for a preloader element on a web page. When the page finishes loading, the code gradually reduces the element's 
    opacity until it becomes completely transparent, and then hides it from view.
*/

function fadeOutElement(elementId, duration, delay) {
    var fadeTarget = document.getElementById(elementId);
    fadeTarget.style.transition = 'opacity ' + duration + 'ms';
    
    setTimeout(function () {
      fadeTarget.style.opacity = 0;
      fadeTarget.addEventListener('transitionend', function() {
        fadeTarget.classList.add('d-none');
      }, { once: true });
    }, delay);
  }
  
  window.addEventListener("load", function () {
    fadeOutElement('preloader', 100, 20);
  });

/* -------- */


/*
    This code manages checkboxes that can be in an "indeterminate" state. It ensures that when an indeterminate checkbox is 
    checked or unchecked, the other checkboxes in its group are also updated accordingly. Additionally, it updates the indeterminate 
    state of the checkbox based on the selection status of the other checkboxes in the group.
*/

function handleIndeterminateCheckboxes() {
  var indeterminateCheckboxes = document.querySelectorAll('input[type="checkbox"][data-group][data-indeterminate]');
  
  if (!indeterminateCheckboxes) return;
  
  indeterminateCheckboxes.forEach(function(indeterminateCheckbox) {
    var groupName = indeterminateCheckbox.dataset.group;
    var checkboxes = document.querySelectorAll('input[type="checkbox"][data-group="' + groupName + '"]:not([id="' + indeterminateCheckbox.id + '"])');

    if (!checkboxes) return;
    
    indeterminateCheckbox.addEventListener('change', function() {
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = indeterminateCheckbox.checked;
      });
      indeterminateCheckbox.indeterminate = false;
    });

    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        var checkedCheckboxes = document.querySelectorAll('input[type="checkbox"][data-group="' + groupName + '"]:not([id="' + indeterminateCheckbox.id + '"]):checked');

        if (!checkedCheckboxes) return;
        
        if (checkedCheckboxes.length === checkboxes.length) {
          indeterminateCheckbox.checked = true;
          indeterminateCheckbox.indeterminate = false;
        } else if (checkedCheckboxes.length === 0) {
          indeterminateCheckbox.checked = false;
          indeterminateCheckbox.indeterminate = false;
        } else {
          indeterminateCheckbox.indeterminate = true;
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', handleIndeterminateCheckboxes);

/* -------- */


/*
  The function 'toggleRowClassOnCheckbox' is designed to manage classes and display of selected rows in an HTML table
*/


function toggleRowClassOnCheckbox(selector, className) {
  // Get all checkboxes by the specified selector
  var checkboxes = document.querySelectorAll(selector);

  // Function to update the count of selected items
  function updateSelectedCount() {
      var selectedCount = document.querySelectorAll(selector + ':checked').length;
      var allContactsElement = document.querySelector('#all-in-table');
      var selectedContactsElement = document.querySelector('#selected-in-table');
      var dataElements = document.querySelectorAll('[data-toggle-on-select]');

      dataElements.forEach(function(dataElement) {
          if (selectedCount > 0) {
              dataElement.classList.remove('d-none');
          } else {
              dataElement.classList.add('d-none');
          }
      });

      if (selectedContactsElement) {
          if (selectedCount > 0) {
              selectedContactsElement.classList.remove('d-none');
              selectedContactsElement.querySelector('strong').textContent = selectedCount;
              if (allContactsElement) {
                  allContactsElement.classList.add('d-none');
              }
          } else {
              selectedContactsElement.classList.add('d-none');
              if (allContactsElement) {
                  allContactsElement.classList.remove('d-none');
              }
          }
      }
  }

  // For each checkbox, add an event handler
  checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function(e) {
          var row = e.target.parentNode.parentNode;
          if (e.target.checked) {
              // If the checkbox is checked, add the class
              row.classList.add(className);
          } else {
              // If the checkbox is unchecked, remove the class
              row.classList.remove(className);
          }

          // After changing the class, update the selected count
          updateSelectedCount();
      });
  });

  // Add a separate event handler for all checkboxes in th element
  var headerCheckboxes = document.querySelectorAll('th input[type=checkbox]');

  headerCheckboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function(e) {
          // Find the parent table for this checkbox
          var table = e.target.closest('table');
          var rows = table.querySelectorAll('tr');
          rows.forEach(function(row) {
              // If the row has a child th element, skip this row
              if (row.querySelector('th')) {
                  return;
              }

              if (e.target.checked) {
                  row.classList.add(className);
                  row.querySelector(selector).checked = true;
              } else {
                  row.classList.remove(className);
                  row.querySelector(selector).checked = false;
              }
          });

          // After changing the class, update the selected count
          updateSelectedCount();
      });
  });

  // Update the count of selected items on page load
  updateSelectedCount();
}

// Using the function:
toggleRowClassOnCheckbox('td input[type=checkbox]', 'table-active');


/* -------- */




/*
  This function, fixShowDropdown, is used to manipulate the z-index CSS property of elements with the class position-right-sticky on a webpage. 
*/

window.fixShowDropdown = function(el){
    const defaultZIndex = 0;
    const highlightedZIndex = 10;

    const stickyElements = document.querySelectorAll('.position-right-sticky');

    stickyElements.forEach((element) => {element.style.zIndex = defaultZIndex});

    const closestStickyElement = el.closest(".position-right-sticky");

    if (closestStickyElement) {
        closestStickyElement.style.zIndex = highlightedZIndex;
    }
}

/* -------- */



/*
  This function called updateClasses that updates the classes of elements on a webpage based on their position on the screen. 
  It uses the querySelectorAll method to find all elements with the attribute data-sticky-bottom-shadow. 
*/

function updateClasses() {
    var stickyElements = document.querySelectorAll('[data-sticky-bottom-shadow]');
  
    stickyElements.forEach(function(stickyElement) {
      var stickyElementBottom = stickyElement.getBoundingClientRect().bottom;
      var classes = JSON.parse(stickyElement.dataset.stickyBottomShadow);  // делаем из строки JSON-объект
  
      function addClasses() {
        Object.keys(classes).forEach(function(className) {
          if (classes[className] === "add") {
            stickyElement.classList.add(className);
          } else if (classes[className] === "remove") {
            stickyElement.classList.remove(className);
          }
        });
      }
  
      function removeClasses() {
        Object.keys(classes).forEach(function(className) {
          if (classes[className] === "add") {
            stickyElement.classList.remove(className);
          } else if (classes[className] === "remove") {
            stickyElement.classList.add(className);
          }
        });
      }
  
      window.innerHeight - stickyElementBottom <= 0 ? addClasses() : removeClasses();
    });
  }
  
  ['scroll', 'resize', 'DOMContentLoaded'].forEach(event => window.addEventListener(event, updateClasses));

  /* -------- */

  document.addEventListener('DOMContentLoaded', function () {
    if (window.popovers) {
      window.popovers.forEach(popover => {
        const button = popover._element;
  
        button.addEventListener('shown.bs.popover', function () {
          button.querySelector('i').classList.replace('fa-regular', 'fa-solid');
        });
  
        button.addEventListener('hidden.bs.popover', function () {
          button.querySelector('i').classList.replace('fa-solid', 'fa-regular');
        });
      });
    }
  });
  
  